'use client';
import { ReactNode, memo } from 'react';
import { IFeatureFlags } from '@/config/feature-flags';
import { GlobalServerConfig } from '@/types_cp/server-config';
import { Provider, createServerConfigStore } from './store';

interface GlobalStoreProviderProps {
  children: ReactNode;
  featureFlags?: Partial<IFeatureFlags>;
  isMobile?: boolean;
  serverConfig?: GlobalServerConfig;
}

export const ServerConfigStoreProvider = memo<GlobalStoreProviderProps>(
  ({ children, featureFlags, serverConfig, isMobile }) => (
    <Provider createStore={() => createServerConfigStore({ featureFlags, isMobile, serverConfig })}>
      {children}
    </Provider>
  ),
);
